// Shared password policy: min 8 chars, 1 uppercase, 1 special character.
export const PW_HINT = "Min 8 characters, 1 uppercase letter, 1 special character";

export function passwordError(pw) {
  if (!pw || pw.length < 8) return "Password must be at least 8 characters long.";
  if (!/[A-Z]/.test(pw)) return "Password must include at least one uppercase letter.";
  if (!/[^A-Za-z0-9]/.test(pw)) return "Password must include at least one special character.";
  return null;
}
